module.exports = __webpack_public_path__ + "img/RX1HS6X8_PM_E_Large.9f0d8c25.jpg";